export const { STD__CONTENT_BASE_API, STD__AUTH_BASE_API, STD__STARGATE_API, STD__STARGATE_SPOCK_API } = process.env;

export const USER_REALM_KEY = 'userRealm';

export const AUTH_API = `${STD__AUTH_BASE_API}/backoffice/v1`;
export const STUDIO_API_V1 = `${STD__CONTENT_BASE_API}/v1`;
export const STUDIO_API_V2 = `${STD__CONTENT_BASE_API}/v2`;
export const STUDIO_API_V3 = `${STD__CONTENT_BASE_API}/v3`;
export const STUDIO_API_V4 = `${STD__CONTENT_BASE_API}/v4`;
